export const DR_OVERVIEW = "drOverview";
export const MANAGE_DR = "manageDr";
export const MANAGE_DRC_VAULT = "manageDrcVault";
export const ROADMAP = "roadmap";
export const FAQS = "faqs";
export const BUY = "buy";
